<template>
    <div id="about" ref="about" class="about">
        <div class="legend">About Me</div>
        <div class="intro">
            <p class="greeting">
                Hi, I'm <b>Dimitris Karageorgos</b>
            </p>
            <p class="description" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="100">
                I’m a Software Engineer with over seven years of experience, based in Athens, Greece. I’m passionate about creating innovative web services and committed to writing clean, elegant, and efficient code. Skilled with cutting‑edge development tools and methodologies, I excel at self‑managing during independent projects and collaborating effectively as part of a high‑performing team.
            </p>
        </div>
        <div class="key-skills" data-aos="fade-right" data-aos-duration="1200" data-aos-delay="300">
            <div class="skills">
                <p class="greeting">
                    <b>Key Skills</b>
                </p>
                <div class="description">
                    <ul>
                        <li>Advanced Analytical Thinking</li>
                        <li>Programming languages</li>
                        <li>Knowledge of AI Integration Across Platforms</li>
                        <li>Organisational and time management skills</li>
                        <li>Software logic</li>
                        <li>Software Troubleshooting</li>
                        <li>Knowledgeable in User Interface/ User Experience</li>
                        <li>Adaptability</li>
                        <li>Accountability</li>
                        <li>Leadership</li>
                        <li>Teamwork</li>
                    </ul>
                </div>
            </div>
            <div class="gif-wrapper">
                <v-img class="animated-gif" :src="require('@/assets/images/computer.gif')" />
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'About',
        updated() {
            console.log('eee')
        }
    }
</script>
<style scoped>
li {
    margin-bottom: 1em;
}

.about {
    font-family: "Poppins";
    width: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    padding-top: 3%;
    padding-left: 5%;
}

.legend {
    font-family: "Poppins-Bold";
    font-size: 2em;
    margin-left: 2%;
}

.greeting {
    font-size: 1.3em;
    padding-top: 4%;
}

.intro {
    max-width: 90%;
}

.description {
    font-size: 1.15em;
    color: #7e7e7e;
}

.key-skills {
    margin-top: 3%;
    display: flex;
    flex-direction: row;
}

.skills {
    width: 50%;
}

.gif-wrapper {
    width: 50%;
    align-self: center;
}

.animated-gif {
    max-width: 550px;
}

@media screen and (max-width: 768px) {
    .about {
        padding-left: none;
    }

    .skills {
        width: 100%;
    }

    .key-skills {
        flex-direction: column;
    }

    .gif-wrapper {
        width: 80%;
    }

}
</style>
